import SyncConfigBaseView from './SyncConfigBaseView';
import { generateEntityPath } from '../../../utils/entity';
import parsers from '../../../utils/parsers';

export default class SyncConfigsView extends SyncConfigBaseView {
  getSyncEndpoint() {
    return this.props.endpoint;
  }

  async loadData() {
    try {
      const { endpoint, actions, entityDef, serviceAlias } = this.props;
      const syncConfig = (await this.props.endpoint.get(this.entityId)).data;
      const sourceConversionRule = (
        await this.props.endpoint.getRuleById(syncConfig.sourceEnv, syncConfig.sourceLiveId)
      ).data;

      const data = {
        ...syncConfig,
        sourceConversionRule: {
          ...parsers.pick({
            value: sourceConversionRule,
            paths: [
              'sourceMessageName',
              'releaseStageName',
              'targetScheme',
              'sourceScheme',
              'inceptionTime',
              'lastModifiedTime',
            ],
          }),
        },
      };

      const path = [...generateEntityPath(endpoint, serviceAlias), this.entityId];
      actions.getEntitySuccess({
        data,
        path,
        pkField: entityDef.pkField,
        replace: true,
      });

      this.onAfterFetch({ data });
    } catch (e) {
      this.genericErrorHandler(e);
    } finally {
      this.setState({ loading: false });
    }
  }
}
